// taken from https://raw.githubusercontent.com/donmccurdy/expression-eval/main/index.ts
export const binops: Record<string, (a: any, b: any) => any> = {
  '||': function (a: any, b: any) {
    return a || b;
  },
  '&&': function (a: any, b: any) {
    return a && b;
  },
  '|': function (a: any, b: any) {
    return a | b;
  },
  '^': function (a: any, b: any) {
    return a ^ b;
  },
  '&': function (a: any, b: any) {
    return a & b;
  },
  '==': function (a: any, b: any) {
    // eslint-disable-next-line eqeqeq
    return a == b;
  },
  '!=': function (a: any, b: any) {
    // eslint-disable-next-line eqeqeq
    return a != b;
  },
  '===': function (a: any, b: any) {
    return a === b;
  },
  '!==': function (a: any, b: any) {
    return a !== b;
  },
  '<': function (a: any, b: any) {
    return a < b;
  },
  '>': function (a: any, b: any) {
    return a > b;
  },
  '<=': function (a: any, b: any) {
    return a <= b;
  },
  '>=': function (a: any, b: any) {
    return a >= b;
  },
  '<<': function (a: any, b: any) {
    return a << b;
  },
  '>>': function (a: any, b: any) {
    return a >> b;
  },
  '>>>': function (a: any, b: any) {
    return a >>> b;
  },
  '+': function (a: any, b: any) {
    return a + b;
  },
  '-': function (a: any, b: any) {
    return a - b;
  },
  '*': function (a: any, b: any) {
    return a * b;
  },
  '/': function (a: any, b: any) {
    return a / b;
  },
  '%': function (a: any, b: any) {
    return a % b;
  },
};

export const unops: Record<string, (a: any) => any> = {
  '-': function (a: any) {
    return -a;
  },
  '+': function (a: any) {
    return +a;
  },
  '~': function (a: any) {
    return ~a;
  },
  '!': function (a: any) {
    return !a;
  },
};

export type BinopsKey = keyof typeof binops;
export type UnopsKey = keyof typeof unops;
